import { LayoutHOC } from "base/ui/layout/layout";
import { createMachineUptime } from "./machineUptime";



export const createMachineUptimePage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createMachineUptime());
};